import AsyncStorage from '@react-native-async-storage/async-storage'
import { isDevice } from 'expo-device'
import * as Notifications from 'expo-notifications'
import { times } from 'lodash'
import { Platform } from 'react-native'
import { buildStorageKey } from 'shared/storage'

export const DEVICE_TOKEN_KEY = 'device_token'

export async function getDeviceToken(): Promise<string> {
  const isiOSSimulator = !isDevice && Platform.OS === 'ios'

  if (Platform.OS === 'web') {
    const webDeviceToken = await AsyncStorage.getItem(
      buildStorageKey(DEVICE_TOKEN_KEY)
    )
    if (webDeviceToken) {
      return webDeviceToken
    }
  }

  if (isiOSSimulator || Platform.OS === 'web') {
    const randomHexToken = times(64, () =>
      ((Math.random() * 0xf) << 0).toString(16)
    ).join('')
    return randomHexToken
  }

  const token = await Notifications.getDevicePushTokenAsync()

  if (token.type !== 'ios' && token.type !== 'android') {
    throw new Error('Platform not supported for push notifications')
  }

  return token.data
}

export async function getPage(): Promise<string | undefined> {
  if (Platform.OS === 'web') {
    try {
      const pageData = await AsyncStorage.getItem(buildStorageKey(PAGE_KEY))
      if (pageData) {
        const parsed = JSON.parse(pageData)
        return parsed.page
      }
    } catch (error) {
      console.error(error)
    }
    return undefined
  }
  return undefined
}

export async function clearPage(): Promise<void> {
  if (Platform.OS === 'web') {
    try {
      await AsyncStorage.removeItem(buildStorageKey(PAGE_KEY))
    } catch (error) {
      console.error(error)
    }
  }
}

const PAGE_KEY = 'page'
